<template>
  <div @click="onReplyEvent(item)">
    <div class="item-container">
      <div class="avatar-container">
        <img class="item-avatar" :src="item.avatar" />
        <img
          class="icon_header_v"
          src="@/static/ic_v_log.png"
          v-if="item.isAuthor"
        />
      </div>
      <div class="right-continer">
        <div class="S4 T3 title-container">
          {{ item.nickname }}
          <span class="S4 T3 item-time"> {{ dayjs(item.createTime).format('MM-DD HH:mm')  }} </span>
        </div>
        <div class="S8 T6 item-comment" :class="commentColor">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'comment-item',

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },

    showReplyCount: {
      type: Boolean,
      default: false
    },

    showDelete: {
      type: Boolean,
      default: true
    },

    showOwner: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    replyTitle() {
      if (this.showReplyCount) {
        return this.item.replyCount + ' 回复'
      } else {
        return '回复'
      }
    },

    commentColor() {
      if (this.item.isAuthor) {
        return 'C9'
      } else {
        return 'T1'
      }
    },

    parentCommentColor() {
      if (this.item.parentComent.isAuthor) {
        return 'C9'
      } else {
        return 'T1'
      }
    }
  },

  methods: {
    dayjs,
    onReplyEvent(item) {
      this.$emit('onReplyEvent', item)
    }
  },

  mounted() {}
}
</script>

<style scoped>
.item-container {
  position: relative;
  display: flex;
  flex-direction: row;
}

.avatar-container {
  height: 71px;
  width: 71px;
  position: relative;
  margin-top: 40px;
  margin-left: 30px;
}

.item-avatar {
  height: 71px;
  width: 71px;
  border-radius: 35px;
}

.icon_header_v {
  width: 26px;
  height: 26px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.right-continer {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-top: 42px;
  position: relative;
  width: 100%;
}

.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.item-comment {
  margin-top: 12px;
  padding: 30px 30px 28px;
  background: #FFFFFF;
  border-radius: 16px;
  margin-right: 36px;
}

.delete-container {
  position: absolute;
  top: 0;
  right: 10px;
  width: 100px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.btn-delete {
  border: 1px solid #262626;
  border-radius: 15px;
  text-align: center;
  width: 60px;
  height: 30px;
}
.item-time {
  position: relative;
  margin-left: 10px;
  padding: 10px;
}
.item-time::before {
  position: absolute;
  left: -2px;
  top: 40%;
  content: '';
  height: 18px;
  width: 1px;
  background-color: #858585;
}
</style>
